import { useMemo } from 'react';
import { generatePath } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import type { PotentialFollowUpOwner } from 'src/types/followUp';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';

const useTicketPotentialOwnersQuery = ({
  ticketId,
  search,
}: {
  ticketId?: number;
  search?: string;
}) => {
  const endpoint = useMemo(
    () =>
      generatePath(apiPaths.FOLLOW_UP.TICKETS.POTENTIAL_OWNERS, {
        id: ticketId ?? 'placeholder-that-will-never-be-used',
      }),
    [ticketId],
  );
  return useQuery<PotentialFollowUpOwner>({
    queryKey: [endpoint, search],
    enabled: !!ticketId,
    queryFn: ({ signal }) =>
      HttpService.get(endpoint, { search }, true, { signal })
        .then((data) => Promise.resolve(data.data))
        .catch(({ response }) => Promise.reject(response.status)),
    keepPreviousData: true,
  });
};

export default useTicketPotentialOwnersQuery;
